// utils/sectionIconMap.js

const sectionIconMap = {
  // Module 1 — 1.1 Welcome
  "Patients":                        "Users",
  "Your clinic":                     "Building2",
  "Your professional license":       "BadgeCheck",
  "Your reputation":                 "ShieldCheck",

  // Module 1 — 1.2 What Is HIPAA?
  "How patient information is used": "Eye",
  "How it is shared":                "Share2",
  "What happens if it is exposed":   "AlertCircle",

  // Module 1 — 1.3 What Is PHI?
  "Name + diagnosis":                        "FileText",
  "Phone number + appointment details":      "Phone",
  "Insurance ID + treatment notes":          "CreditCard",
  "Date of birth + medical condition":       "Calendar",

  // Module 1 — 1.4 Who Must Follow HIPAA?
  "Heavy fines — Substantial financial penalties for non-compliance":          "DollarSign",
  "Government investigations — Rigorous audits from federal regulatory bodies": "Search",
  "Lawsuits & Public breach reporting":                                         "Scale",
  "Reputation damage — Long-term loss of patient trust":                        "ThumbsDown",

  // Module 1 — 1.8 Your Personal Responsibility
  "Information Security — Protecting patient information": "ShieldCheck",
  "Verbal Privacy — Speaking carefully":                   "MessageSquare",
  "Access Control — Securing access to systems":           "KeyRound",
  "Instant Reporting — Reporting mistakes immediately":    "Bell",
};

export default sectionIconMap;




